import cx from 'classnames';
import type { ReactNode } from 'react';
import type { DefaultLinkImplementationProps, LinkImplementationRequiredProps, LinkProps } from '../Link';
import { Link } from '../Link';
import { Typography } from '../Typography';
import styles from './styles.module.css';

export type MenuItemProps<P extends LinkImplementationRequiredProps> = LinkProps<P> & {
  selected?: boolean;
};

function MenuItem<P extends LinkImplementationRequiredProps = DefaultLinkImplementationProps>({
  selected,
  ...props
}: MenuItemProps<P>): ReactNode {
  return (
    <li
      className={cx(styles.MenuItem, {
        [styles.MenuItemSelected]: selected,
      })}
    >
      <Link {...props} />
    </li>
  );
}

export interface MenuProps {
  title?: string | ReactNode;
  children: NonNullable<ReactNode>;
}

export function Menu({ title, children }: MenuProps): ReactNode {
  return (
    <div>
      {title && (
        <div className={styles.MenuTitle}>
          <Typography.div variant="bold" base="header4" medium="body-medium">
            {title}
          </Typography.div>
        </div>
      )}
      {children}
    </div>
  );
}

Menu.Item = MenuItem;
